import {
  GetWebsiteReferralCodeQuery,
  GetWebsiteReferralCodeQueryVariables
} from '@data/__generated__/types.main'
import {useApolloQuery} from 'apollo-hooks'
import {UseQueryOptions} from 'apollo-hooks/dist/useQueryBase'
import gql from 'graphql-tag'

import useWebsiteId from './useWebsiteId'

export default function useReferralCode(
  opts: Partial<
    UseQueryOptions<GetWebsiteReferralCodeQuery, GetWebsiteReferralCodeQueryVariables>
  > = {}
) {
  const websiteId = useWebsiteId()

  const {data} = useApolloQuery<GetWebsiteReferralCodeQuery, GetWebsiteReferralCodeQueryVariables>({
    query: gql`
      query getWebsiteReferralCode($websiteId: ID!) {
        getReferralCode(websiteId: $websiteId)
      }
    `,
    fetchPolicy: 'cache-first',
    variables: {websiteId},
    ...opts
  })

  return data.getReferralCode?.toUpperCase()
}
